import { render, staticRenderFns } from "./bind_location_info.vue?vue&type=template&id=2d56583e"
import script from "./bind_location_info.vue?vue&type=script&lang=js"
export * from "./bind_location_info.vue?vue&type=script&lang=js"
import style0 from "./bind_location_info.vue?vue&type=style&index=0&id=2d56583e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports